var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruckMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "68px",
    height: "68px",
    viewBox: "0 0 68 68",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Truck") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.8181818,32.5 L41.8181818,28.9057273 L45.2277686,28.9057273 L47.9054545,32.5 L41.8181818,32.5 Z M43.1818182,41.8442727 C42.0512397,41.8442727 41.1368595,40.8751364 41.1368595,39.6875 C41.1368595,38.4946364 42.0512397,37.5307273 43.1818182,37.5307273 C44.3104132,37.5307273 45.2277686,38.4946364 45.2277686,39.6875 C45.2277686,40.8751364 44.3104132,41.8442727 43.1818182,41.8442727 Z M26.8181818,41.8442727 C25.688595,41.8442727 24.7732231,40.8751364 24.7732231,39.6875 C24.7732231,38.4946364 25.688595,37.5307273 26.8181818,37.5307273 C27.9467769,37.5307273 28.8641322,38.4946364 28.8641322,39.6875 C28.8641322,40.8751364 27.9467769,41.8442727 26.8181818,41.8442727 Z M45.9100826,26.75 L39.8069421,26.75 L39.8069421,35.5004545 L38.3818182,35.5004545 L38.3818182,21 L22.7272727,21 C21.218843,21 20,22.2838182 20,23.875 L20,39.6875 L22.7272727,39.6875 C22.7272727,42.0659091 24.5590083,44 26.8181818,44 C29.0773554,44 30.9090909,42.0659091 30.9090909,39.6875 L39.0909091,39.6875 C39.0909091,42.0659091 40.9216529,44 43.1818182,44 C45.4409917,44 47.2727273,42.0659091 47.2727273,39.6875 L50,39.6875 L50,32.5 L45.9100826,26.75 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shipments",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shipments-List---Shipper",
    transform: "translate(-1123.000000, -447.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Truck",
    transform: "translate(1123.000000, 447.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    fill: "#33CC60"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.3,
    cx: 34,
    cy: 34,
    r: 34
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.3,
    cx: 34,
    cy: 34,
    r: 28
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.7,
    cx: 34,
    cy: 34,
    r: 22
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-71",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#333E48",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    strokeWidth: 2,
    d: "M42.8181818,31.5 L45.9134691,31.5 L44.7257569,29.9057273 L42.8181818,29.9057273 L42.8181818,31.5 Z M43.1818182,40.8442727 C43.7451449,40.8442727 44.2277686,40.3351664 44.2277686,39.6875 C44.2277686,39.0367626 43.7472526,38.5307273 43.1818182,38.5307273 C42.6155916,38.5307273 42.1368595,39.0355598 42.1368595,39.6875 C42.1368595,40.3363701 42.6176975,40.8442727 43.1818182,40.8442727 Z M26.8181818,40.8442727 C27.3815085,40.8442727 27.8641322,40.3351664 27.8641322,39.6875 C27.8641322,39.0367626 27.3836162,38.5307273 26.8181818,38.5307273 C26.2525251,38.5307273 25.7732231,39.0359914 25.7732231,39.6875 C25.7732231,40.3359381 26.2546315,40.8442727 26.8181818,40.8442727 Z M48.1823835,40.6875 C47.7345594,43.1345971 45.6743665,45 43.1818182,45 C40.6886311,45 38.6288846,43.1348061 38.1812115,40.6875 L31.8187472,40.6875 C31.370923,43.1345971 29.3107302,45 26.8181818,45 C24.3256335,45 22.2654406,43.1345971 21.8176165,40.6875 L19,40.6875 L19,23.875 C19,21.7432943 20.6541336,20 22.7272727,20 L39.3818182,20 L39.3818182,25.75 L46.4259575,25.75 L51,32.1806298 L51,40.6875 L48.1823835,40.6875 Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckMarker);
export default __webpack_public_path__ + "static/media/truck-marker.cb961e87647d38337f4efb6de4702b2f.svg";
export { ForwardRef as ReactComponent };